/**
 * Phase 41 (Plan 41-15 Task 2) — Sidebar v3 Customer to Project hierarchy
 * hook.
 *
 * TanStack Query wrapper around fetchSidebarCustomers. The data is small
 * (one row per customer + its membered projects) and rarely changes mid-
 * session, so we use a 5-minute staleTime to avoid refetch storms when the
 * Sidebar re-renders on route navigation.
 */
import { useQuery } from '@tanstack/react-query';
import { fetchSidebarCustomers, type SidebarCustomer } from '../services/api/sidebar';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export function useSidebarCustomers() {
  return useQuery<SidebarCustomer[]>({
    queryKey: ['sidebar', 'customers'],
    queryFn: fetchSidebarCustomers,
    staleTime: FIVE_MINUTES_MS,
  });
}
